// neuAnlageEintraege.ts — die acht Einträge des „+“-Menüs im App-Header.
//
// PO 28.09.2026: „Kontakt, Risiko, Vertrag, Schaden, Vorgang, Termin, Mail,
// Dokument — also wirklich nur diese Nomen". Die Reihenfolge ist Vorgabe,
// nicht Zufall; der Test hält sie fest.
//
// `recht`: Einträge, deren Anlage an einem Recht hängt, erscheinen nur mit
// diesem Recht (dieselben Schlüssel wie die Routen-Guards in App.tsx). Termin
// und Mail hängen am Postfach, nicht an der RBAC-Matrix — wie bisher im Menü
// und in der Sidebar ohne Recht. Ein Dokument braucht einen Kontakt, also
// mindestens dessen Leserecht.

export type NeuAnlageArt =
  | "kontakt"
  | "risiko"
  | "vertrag"
  | "schaden"
  | "vorgang"
  | "termin"
  | "mail"
  | "dokument";

export type NeuAnlageEintrag = {
  art: NeuAnlageArt;
  label: string;
  recht?: string;
};

export const NEU_ANLAGE_EINTRAEGE: readonly NeuAnlageEintrag[] = [
  { art: "kontakt", label: "Kontakt", recht: "contacts:create" },
  { art: "risiko", label: "Risiko", recht: "risks:create" },
  { art: "vertrag", label: "Vertrag", recht: "contracts:create" },
  { art: "schaden", label: "Schaden", recht: "damages:create" },
  { art: "vorgang", label: "Vorgang", recht: "vorgaenge:create" },
  { art: "termin", label: "Termin" },
  { art: "mail", label: "Mail" },
  { art: "dokument", label: "Dokument", recht: "contacts:read" },
];

/** Die Einträge, die der Nutzer sehen darf — Reihenfolge bleibt erhalten. */
export const sichtbareEintraege = (
  hatRecht: (recht: string) => boolean,
): NeuAnlageEintrag[] =>
  NEU_ANLAGE_EINTRAEGE.filter((e) => !e.recht || hatRecht(e.recht));

/** Einträge, die vor dem Anlegen im eigenen Dialog nachfragen. */
export const MIT_VORFRAGE: ReadonlySet<NeuAnlageArt> = new Set([
  "risiko",
  "vertrag",
  "schaden",
  "dokument",
]);
